// extracted by mini-css-extract-plugin
export default {"auth":"style_auth__dzf-e","authContainer":"style_authContainer__uno2s"};